import { ListData } from '@fi-app/components/items-list/list-data.service';
import {
    ItemsListElementType,
    ItemsListHeader,
    ItemsListHeaderProperties,
} from '@fi-app/components/items-list/items-list-header';
import { CentralBillingUnitModuleModel } from '../billing-central/central-billing-unit-module.model';
import { Injector } from '@angular/core';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';

export class BillingUnitListData extends ListData<CentralBillingUnitModuleModel> {
    constructor(injector: Injector) {
        super(injector, true, 'ModuleTypeName');

        this.ShowDelete = false;

        this.Header.push(
            new ItemsListHeader(
                this.appTextService.get('common.module'),
                'ModuleTypeName',
                new ItemsListHeaderProperties('CcmListItem-Name', true, ItemsListElementType.A, {
                    Sref: FiStateNames.Billing.Unit.View,
                    SrefParams: (data) => ({ ModuleType: data.ModuleType, UnitId: data.BusinessUnitId }),
                }),
            ),
        );

        this.addSpanPlainHeader(this.appTextService.get('billing.local_status'), 'IsEnabledText');
        this.addSpanPlainHeader(this.appTextService.get('billing.billing'), 'BillingTypeName');
        this.addSpanPlainHeader(this.appTextService.get('billing.central_billing_level'), 'CentralPackageTypeName');
        this.addSpanPlainHeader(this.appTextService.get('billing.unit_billing_level'), 'PackageTypeName');
    }
}
